/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Unlock_Card2_TitleInputs */

const en_home_unlock_card2_title = /** @type {(inputs: Home_Unlock_Card2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 Support Access`)
};

const fr_home_unlock_card2_title = /** @type {(inputs: Home_Unlock_Card2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès au soutien 24/7`)
};

/**
* | output |
* | --- |
* | "24/7 Support Access" |
*
* @param {Home_Unlock_Card2_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_card2_title = /** @type {((inputs?: Home_Unlock_Card2_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_Card2_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_card2_title(inputs)
	return fr_home_unlock_card2_title(inputs)
});